import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-tertiary-navbar',
  templateUrl: './tertiary-navbar.component.html',
  styleUrls: ['./tertiary-navbar.component.scss'],
})
export class TertiaryNavbarComponent implements OnInit, OnDestroy {
  @Input() navItems: any[] = [];
  @Input() defaultActiveItemId: string = '';

  @Output() appNavbarItemClick = new EventEmitter<any>();

  activeItemId: string = this.defaultActiveItemId;
  activeSubItemId: string = '';
  routerEventsSub: Subscription = null;

  constructor(private router: Router) {}

  ngOnInit() {
    this.activeItemId = this.defaultActiveItemId;
    this.setActiveRoute(this.router.url);
    this.routerEventsSub = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((activeRoute: any) => {
      const url: string = activeRoute.url;
      this.setActiveRoute(url);
    });
  }

  ngOnDestroy() {
    if (this.routerEventsSub) {
      this.routerEventsSub.unsubscribe();
    }
  }

  setActiveRoute = (url: string) => {
    if (this.navItems) {
      for (let i = 0; i < this.navItems.length; i++) {
        const activeLinks = this.navItems[i].activeLinks;

        for (let j = 0; j < activeLinks && activeLinks.length; j++) {
          if (url.includes(activeLinks[j])) {
            this.activeItemId = this.navItems[i].id;
          }
        }

        if (this.navItems[i].items && this.navItems[i].items.length) {
          this.navItems[i].items.forEach(({ activeLinks = [], id }) => {
            for (let j = 0; j < activeLinks.length; j++) {
              if (url.includes(activeLinks[j])) {
                this.activeItemId = this.navItems[i].id;
                this.activeSubItemId = id;
              }
            }
          });
        }
      }
    }
  };

  onNavbarItemClick(item: any) {
    if (item && item.items && item.items.length) {
      return;
    }

    this.appNavbarItemClick.emit(item);
    this.activeItemId = item.id;
    this.activeSubItemId = '';
  }

  onNavbarSubItemClick(item: any, subItem: any, event: any) {
    event.stopPropagation();
    this.activeItemId = item.id;
    this.activeSubItemId = subItem.id;
  }
}
